import { fromJS } from 'immutable';
import { defaultCountry } from '../../FastCover/dataMapper/claimCodeMapper';


import {
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_ADDRESS,
  FNOL_GET_PAYMENT_CODE_TYPES_SUCCESS,
  FNOL_GET_PAYMENT_FORM_FIELDS_SUCCESS,
  FNOL_SET_DYNAMIC_FIELD_VALUE,
  FNOL_RESET_DYNAMIC_FORM,
  FNOL_SET_SELECTED_CODE_TYPE,
  FNOL_VALIDATE_CODE_FIELD,
  FNOL_SET_CODE_VERIFICATION_FAILED,
} from './constants';

import {
  GET_VALIDATE_SUCCESS,
} from '../../FastCover/constants';

// The initial state of the App
const initialState = fromJS({
  form: {
    paymentTo: 'Member',
    paymentVia: 'EFT',
    title: '',
    firstName: '',
    lastName: '',
    addressLine1: '',
    addressLine2: '',
    country: {
      id: defaultCountry.id,
      label: defaultCountry.name,
      value: defaultCountry.name,
    },
    state: '',
    city: '',
    postalZipCode: '',
    mobile: '',
    // new bank details
    bankTypeCode: 'Bank Code',
    bankCodeOrRoutingNumber: '',
    isValidate: false,
    isVerified: false,
    bank: '',
    bankAddress: '',
    bankSuburbOrCity: '',
    bankPostcode: '',
    bankBranch: '',
    bankAccountName: '',
    bankAccountNumber: '',
    swiftCode: '',
    iban: '',
    paymentTypeOptions: [],
    reValidateForm: false,
    //----------------
    isCheckPayment: false,
  },
  errors: [],
  dynamicPaymentCodeTypes: [],
  dynamicPaymentFormFields: [],
  dynamicFormValues: {},
  selectedCodeTypeId: null,
  dynamicCodeVerificationFailed: false,
});

const initialAddress = {
  form: {
    addressLine1: '',
    addressLine2: '',
    firstName: '',
    mobile: '',
    lastName: '',
    title: '',
    state: '',
    country: null,
    postalZipCode: '',
    city: '',
  },
};

function jira_ta1734_invalidateCountryField(formData) {
  if (!formData.country) {
    return formData;
  }
  const isNumeric = (num) => (typeof (num) === 'number' || typeof (num) === "string" && num.trim() !== '') && !isNaN(num);
  if (!isNumeric(formData.country)) {
    formData.country = '';
  }
  return formData;
}

function stepPaymentDetailsReducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED:
      return state.setIn(properties, action.value);
    case LOAD:
      if (action.payload) {
        return initialState.merge(fromJS({
          form: action.payload,
          errors: [],
          dynamicFormValues: action.payload.dynamicFormValues || {},
          dynamicPaymentFormFields: action.payload.dynamicPaymentFormFields || [],
        }));
      }
      return initialState;
    case NEXT:
      return state.merge({ errors: action.errors });
    case RESET:
      return initialState;
    case RESET_ADDRESS:
      return state.mergeDeep(initialAddress);
    case GET_VALIDATE_SUCCESS:
      return state.mergeDeep({ form: action.bankInfo });
    case FNOL_GET_PAYMENT_CODE_TYPES_SUCCESS:
      return state
        .set('dynamicPaymentCodeTypes', fromJS(action.data || []))
        .set('selectedCodeTypeId', action.data && action.data.length > 0 ? action.data[0].id : null);
    case FNOL_GET_PAYMENT_FORM_FIELDS_SUCCESS:
      return state
        .set('dynamicPaymentFormFields', fromJS(action.data || []))
        .set('dynamicFormValues', fromJS({}));
    case FNOL_SET_DYNAMIC_FIELD_VALUE:
      return state.setIn(['dynamicFormValues', action.fieldName], action.value);
    case FNOL_SET_SELECTED_CODE_TYPE:
      return state.set('selectedCodeTypeId', action.codeTypeId);
    case FNOL_VALIDATE_CODE_FIELD:
      return state.set('dynamicCodeVerificationFailed', false);
    case FNOL_SET_CODE_VERIFICATION_FAILED:
      return state.set('dynamicCodeVerificationFailed', true);
    case FNOL_RESET_DYNAMIC_FORM:
      return state
        .set('dynamicPaymentCodeTypes', fromJS([]))
        .set('dynamicPaymentFormFields', fromJS([]))
        .set('dynamicFormValues', fromJS({}))
        .set('selectedCodeTypeId', null)
        .set('dynamicCodeVerificationFailed', false);
    default:
      return state;
  }
}

export default stepPaymentDetailsReducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepPaymentDetails/reducer.js